import { render, staticRenderFns } from "./DictionaryPage.vue?vue&type=template&id=00c965ae"
import script from "./DictionaryPage.vue?vue&type=script&lang=js"
export * from "./DictionaryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports